import React from 'react';
import logo from '../logo.png';


function RadikleSignInButtonV2({redirectToRadikleOAuth}) {
  return (
    <button
      className="Singin-button"
      onClick={redirectToRadikleOAuth}
      style={{
        display: 'flex',
        alignItems: 'center',
        color: 'white',
        backgroundColor: '#259fc1',
        borderRadius: '5px',
        border: 'none',
        textAlign: 'center',
        fontSize: '14px',
        padding: '0px',
        width: '245px',
        height: '37px',
        cursor: 'pointer',
        margin: '2px'
      }}
    >
      <img
        src={logo} // Replace with your custom icon path
        alt="Radikle Icon"
        style={{ width: '55px', height: '55px' }}
      />
      SIGN IN WITH RADIKLE
    </button>
  );
}

export default RadikleSignInButtonV2;